import { useContext } from "react";
import "./style.css";
import { ThemeContext } from "../../App";

const ThemeButton = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <button
      style={
        theme
          ? {
              backgroundColor: "#fafafa",
              color: "#000",
              border: "1px solid #cecece",
            }
          : {}
      }
      onClick={() => {
        localStorage.setItem("theme", JSON.stringify({ themeStatus: !theme }));
        setTheme(!theme);
      }}
      className="themeButton"
    >
      Change Theme
    </button>
  );
};

export default ThemeButton;
